import { RouteObject, defer } from 'react-router-dom'
import AppRoot from './AppRoot'
import {
  NonReactRoute,
  PageLoadingSupport,
  FullPageError,
} from '$components/common'
import { AppDialogProvider, SideNavAwareFileViewerProvider } from '$hooks'
import { isAppStateReady } from '$appStore'
import { companyRoutes } from './routes/settings/company/Routes'
import { complianceRoutes } from './routes/time/compliance/Routes'
import { timeclockRoutes } from './routes/time/timeclock/Routes'
import { payrollRoutes } from './routes/time/payroll/Routes'
import { workforceRoutes } from './routes/time/workforce/Routes'
import { rosterRoutes } from './routes/time/roster/Routes'
import { stockRoutes } from './routes/stock/Routes'
import { connectionRoutes } from './routes/connections/Routes'

/**
 * A `react-router` router definition array. Each object in this array
 * represents a url that should have a React component rendered on it.
 *
 * Note that while it might seem tidy to push the `PageLoadingSupport`
 * component into each of the page definitions themselves it's not done
 * that way so that we don't end up with the code for that included in
 * each page bundle. Our app bundler is splitting the pages into separate
 * files that get downloaded, this way the `PageLoadingSupport` component
 * is only included once in the main bundle.
 */
export default [
  {
    element: (
      <PageLoadingSupport>
        <AppDialogProvider>
          <SideNavAwareFileViewerProvider>
            <AppRoot />
          </SideNavAwareFileViewerProvider>
        </AppDialogProvider>
      </PageLoadingSupport>
    ),
    loader: async () => {
      // We wait for the AppContext to be ready (i.e. it's got data available)
      // before we start rendering the app. This makes the interface for client
      // code to interact with the AppContext simpler as they can rely on it
      // being available when they need it.
      return defer({
        data: await isAppStateReady(),
      })
    },
    errorElement: <FullPageError marginLeft="230px" />,
    children: [
      ...companyRoutes,
      ...complianceRoutes,
      ...timeclockRoutes,
      ...payrollRoutes,
      ...workforceRoutes,
      ...rosterRoutes,
      ...stockRoutes,
      ...connectionRoutes,
      {
        path: '*',
        element: <NonReactRoute />,
      },
    ],
  },
] as RouteObject[]
